'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.weeksFromNow;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/date/weeksFromNow.js
// module id = 296
// module chunks = 1